
























































































import { Vue, Component } from "@/shared/vuepack";
import { Validator } from "vee-validate";
import { EplItemStatus, eplItemStatusIconMap, EplLookupMethod } from "@/shared/types";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import SigisLicenseAgreement from "@/employee/components/product-scanner/SigisLicenseAgreement.vue";
import { useProductScannerStore } from "@/employee/store/productScanner";
import { useSigningDocumentStore } from "@/admin/store/signingDocument";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useNotifierStore } from "@/shared/store/notifier";
import * as datadog from "@/shared/datadog";
import { barcodeScanner } from "@/shared/nativePlugins";
import { Html5QrcodeSupportedFormats } from "@/shared/nativePlugins/types";

@Component({
  components: {
    GenericLoadingSpinner,
    SigisLicenseAgreement
  }
})
export default class ProductScanner extends Vue {
  $validator: Validator;
  Html5QrcodeSupportedFormats = Html5QrcodeSupportedFormats;

  productScannerStore = useProductScannerStore();
  signingDocumentStore = useSigningDocumentStore();
  hsabAccountsStore = useHsabAccountsStore();
  notifierStore = useNotifierStore();

  manualEntry = false;
  productCode = "";
  statusIcon = eplItemStatusIconMap[EplItemStatus.None];
  statusMessage = "";
  unsupportedCode = false;
  // Note: Apple Vision does not distinguish between UPC_A and EAN_13.
  supportedFormats = [Html5QrcodeSupportedFormats.UPC_A, Html5QrcodeSupportedFormats.EAN_13, Html5QrcodeSupportedFormats.ITF];
  minLength = 12;
  maxLength = 14;


  get scanOptionsHeader () {
    return this.productScannerStore.awaitingScan
      ? "Select an option below:"
      : "Check eligibility of another product:";
  }

  get showDisclaimer () {
    return this.hsabAccountsStore.userHasAnyNotionalAccounts;
  }

  get showResults () {
    return !this.productScannerStore.awaitingScan || this.unsupportedCode;
  }

  mounted () {
    this.productScannerStore.initializeState();
  }

  onManualEntryClick () {
    this.manualEntry = true;
    this.$nextTick(() => {
      (this.$refs.productCodeInput as any).focus();
    });
  }

  lookupProductCode () {
    this.$validator.validate()
      .then(isValid => {
        if (!isValid) {
          return;
        }

        this.lookup(this.productCode, EplLookupMethod.ManualEntry);
      });
  }

  lookup (productCodeString: string, method: EplLookupMethod) {
    this.unsupportedCode = false;
    this.productScannerStore.lookupItem({ productCode: productCodeString, method })
      .then(response => {
        this.statusIcon = eplItemStatusIconMap[response.status];
        this.statusMessage = response.statusMessage;
        this.manualEntry = false;
        this.productCode = "";
      })
      .catch(() => {/* noop */ });
  }

  openScannerWindow () {
    return barcodeScanner.scanBarcode()
    .then(result => {
      if (result) {
        const { isValid, trimmedBarcode } = this.validateAndReturnTrimmedBarcode(result.format, result.ScanResult);
        if (isValid) {
          this.lookup(trimmedBarcode, EplLookupMethod.Scan);
        } else {
          datadog.log("Unsupported barcode found.", {format: result.format, code: trimmedBarcode}, "info");
          this.productScannerStore.initializeState();
          this.statusIcon = eplItemStatusIconMap[EplItemStatus.Invalid];
          this.statusMessage = "Not supported. Please try another product.";
          this.unsupportedCode = true;
        }
      }
    })
    .catch(_ => {
      this.notifierStore.setDanger("Error processing your request. Please try again later.");
    });
  }

  validateAndReturnTrimmedBarcode (format: number, code: string) {
    const normalized = code.trim().toUpperCase();
    const length = normalized.length;

    if (!this.supportedFormats.includes(format) || length < this.minLength) {
      return { isValid: false, trimmedBarcode: normalized };
    }

    let trimmedBarcode = normalized;

    if (length > this.maxLength) {
      trimmedBarcode = normalized.slice(-this.maxLength);
    } else if (length > this.minLength && length !== this.maxLength) {
      trimmedBarcode = normalized.slice(-this.minLength);
    }

    return { isValid: true, trimmedBarcode };
  }
}
